import base from '@/http/url_base';

export default {
  CATALOGUE: base.API + '/catalogue-articles',
  CATALOGUE_DETAIL: base.API + '/catalogue-articles/details',
  CATALOGUE_SEARCH_TIERS: base.API + '/catalogue-articles/search-tiers',
  GET_REQUIREMENTS: base.API + '/catalogue-articles/requirements',
};
